import type { WorkspaceVisualIdentityTheme } from '@/features/workspace/types';

export interface ThemePresetColors {
  accentColor: string;
  backgroundColor: string;
  secondaryBackgroundColor: string;
  contrastColor: string;
}

// Palettes de base clair et sombre, lisibles telles quelles sans retouche manuelle.
// Source unique partagee par le selecteur de base de theme et l'apercu.
export const THEME_PRESETS: Record<WorkspaceVisualIdentityTheme, ThemePresetColors> = {
  LIGHT: {
    accentColor: '#2EFFB8',
    backgroundColor: '#FBFBFB',
    secondaryBackgroundColor: '#F3F3F4',
    contrastColor: '#2C6CFF',
  },
  DARK: {
    accentColor: '#95B6FF',
    backgroundColor: '#0C0E21',
    secondaryBackgroundColor: '#1B1E3B',
    contrastColor: '#2C6CFF',
  },
};
